import { Button } from 'react-bootstrap'
import Modal from 'components/Modal/Modal'
import { showCalculator } from 'redux/features/bienAVendre/slice'
import { useAppSelector, useAppDispatch } from 'redux/hooks'
import { calculAllSurfaces } from 'utils/calculSurfaces'
import {
  makeSelectSurfaceHabitable,
  makeSelectShowedCalculator,
  makeSelectEtages,
  makeSelectGaragePosition,
  makeSelectGarageSpace,
} from 'redux/features/bienAVendre/selectors'
import styles from './CalculationResult.module.scss'

interface Props {
  onValidateButtonClick: () => void
  onResetButtonClick: () => void
}

const CalculationResult = ({
  onValidateButtonClick,
  onResetButtonClick,
}: Props): JSX.Element => {
  const surfaceHabitable = useAppSelector(makeSelectSurfaceHabitable)
  const showedCalculator = useAppSelector(makeSelectShowedCalculator)
  const etages = useAppSelector(makeSelectEtages)
  const garagePosition = useAppSelector(makeSelectGaragePosition)
  const garageSpace = useAppSelector(makeSelectGarageSpace)

  const dispatch = useAppDispatch()

  const validation = () => {
    dispatch(showCalculator(false))
    onValidateButtonClick()
  }

  let resume = `Erreur: une surface habitable doit être renseignée pour estimer l'emprise au sol`
  if (surfaceHabitable !== null) {
    const { surfaceAuSolMin: newAuSolMin, surfaceAuSolMax: newAuSolMax } =
      calculAllSurfaces({
        surfaceInput: surfaceHabitable,
        calculViaConfigurateurAvance: true,
        garagePosition,
        tailleGarage: garageSpace,
        etages,
      })
    resume = `de ${newAuSolMin} à ${newAuSolMax} m²`
  }

  return (
    <Modal
      show={showedCalculator}
      title="Calculateur avancé de l'emprise au sol estimée"
      body={
        <div className={styles.calculationResult}>
          <h1 className={styles.title}>
            Voici le résultat de la surface estimée :
          </h1>
          <div className={styles.result}>{resume}</div>
        </div>
      }
      footer={
        <>
          <Button variant="outline-primary" onClick={onResetButtonClick}>
            Recommencer
          </Button>
          <Button variant="primary" onClick={validation}>
            Valider
          </Button>
        </>
      }
      onCloseButtonClick={() => dispatch(showCalculator(false))}
    />
  )
}

export default CalculationResult
